export const passwordValidators = Object.freeze([
  { required: true, message: '请输入密码', trigger: 'change' },
  {
    validator(rule, val) {
      const len = val.length
      if (len < 6 || len > 18) {
        return Promise.reject('密码长度为6-18个字符')
      }
      if (/^[A-Za-z0-9@_]{6,18}$/.test(val)) {
        return Promise.resolve()
      }
      return Promise.reject('密码由字母、数字、@、_组成')
    }
  }
])

export function hasOwnerProperty(obj, property) {
  return Object.prototype.hasOwnProperty.call(obj, property)
}
